{
  const slider = tns({
    container: ".carousel__wrapper",
    items: 1,
    slideBy: "page",
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    adaptiveHeight: true,
    controlsText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>'
    ],
    responsive: {
      1024: {
        controls: true
      }
    }
  });
}
